import { AddMoreIngredientsButton } from './components';

export const CustomizationReview = {
  AddMoreIngredientsButton,
};
